import * as React from "react";
import {ReactElement} from "react";
import {useStoreValue} from "react-context-hook";
import {getText} from "../../services/configuration.service";

const PromoProduct = (): ReactElement => {
    const bookingEngineData = useStoreValue("bookingEngineData");
    const product = (bookingEngineData || {}).product;
    const promoProduct = product && product.promoProduct;
    return (
        <div>
            {promoProduct && promoProduct.label &&
            <div className="special-offer d-none d-lg-block">
                {promoProduct.label} <a href={`/${promoProduct.code}`} className="link-decoration">{getText("booking.promo.product.label")}</a>
            </div>
            }
        </div>
    );
};

export default PromoProduct;
